module.exports = __webpack_public_path__ + "dashboard/img/folder_open.b761b7e17ea6f012e6c590c57759ba2e.svg";